<template>
  <el-dialog
    :visible.sync="visible"
    :show-close="true"
    width="400px"
    custom-class="mini-program-dialog"
    top="15vh"
    :close-on-click-modal="true"
  >
    <div class="mini-body">
      <div class="mini-icon">
        <i class="fab fa-weixin"></i>
      </div>
      <h3 class="mini-title">小程序</h3>
      <p class="mini-desc">使用微信扫描下方小程序码</p>
      <div class="mini-qr-wrap">
        <img src="/mini-qr.png" alt="小程序码" class="mini-qr" />
      </div>
      <p class="mini-tip">
        <i class="fas fa-mobile-alt"></i>
        手机用户点击后自动拉起微信，如未跳转请扫码
      </p>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'MiniProgramModal',
  data() {
    return {
      visible: false
    }
  },
  methods: {
    show() {
      this.visible = true
    }
  }
}
</script>

<style scoped>
.mini-body {
  text-align: center;
  padding: 0.5rem 0 1rem;
}

.mini-icon {
  font-size: 3.5rem;
  color: #07c160;
  margin-bottom: 0.5rem;
}

.mini-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.3rem;
}

.mini-desc {
  font-size: 0.85rem;
  color: #64748b;
  margin: 0 0 1.2rem;
}

.mini-qr-wrap {
  display: inline-block;
  padding: 12px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.08);
  border: 1px solid #edf2f7;
}

.mini-qr {
  width: 220px;
  height: 220px;
  display: block;
}

.mini-tip {
  margin-top: 1rem;
  font-size: 0.75rem;
  color: #94a3b8;
}

.mini-tip i {
  margin-right: 4px;
}
</style>

<style>
.mini-program-dialog {
  border-radius: 28px !important;
  overflow: hidden;
}
.mini-program-dialog .el-dialog__header {
  padding: 12px 20px 0;
}
.mini-program-dialog .el-dialog__title {
  display: none;
}
.mini-program-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #1a5a36;
}
.mini-program-dialog .el-dialog__body {
  padding: 2rem 2rem 1.5rem;
}
</style>
